import React from 'react'
import { BLOCKS, MARKS } from "@contentful/rich-text-types"
import { renderRichText } from "gatsby-source-contentful/rich-text"

import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const Bold = ({ children }) => <span className="bold">{children}</span>
const Text = ({ children }) => <p className="my-5 align-center body-text standard is-size-4 column is-10 is-offset-1 has-text-justified has-text-left-mobile">
                                    {children}
                                </p>


const BodyTextTemplate = ({ richTextField, assetData }) => {
    let assetNodeCount = 0

    const options = {
        renderMark: {
            [MARKS.BOLD]: text => <Bold>{text}</Bold>,
        },
      renderNode: {
        [BLOCKS.PARAGRAPH]: (node, children) => <Text>{children}</Text>,
        [BLOCKS.EMBEDDED_ASSET]: node => {
          if(assetData){
            const imageId = node.data.target.sys.id
            assetNodeCount += 1
            
            const {
                gatsbyImageData,
                title
            } = assetData.find(({contentful_id: id}) => id === imageId);

            const position = assetNodeCount % 2 !== 0 ? 'is-pulled-left' : 'is-pulled-right'
        
            return <GatsbyImage image={getImage(gatsbyImageData)} alt={title} className={`blogpost-image ${position} mb-6`} />
          } else {
            return <></>
          }
        },
      },
    }

    return (
      renderRichText(richTextField, options)
    )
}

export default BodyTextTemplate